import { useContext } from 'react';
import { useValidateDraftCondition } from '../../hooks/useValidateDraftCondition';
import { useViewerActions } from '../../hooks/useViewerActions';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import LogicGroupsDivider from '../common/LogicGroupsDivider';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerAddGroup = ({
  showLogicGroupOperatorToggle = false,
  showLogicGroupOperatorToggles = false
}) => {
  const {
    internalDraftValue,
    draftCondition,
    isInEditMode,
    props: {
      isAndGroup,
      isReadOnly,
      editButtonsState,
      uiMessages: {
        viewerEmptyFilters,
        addFilterButtonLabel,
        addFilterGroupButtonLabel
      },
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    onAddFilterGroup,
    onAddFirstFilterGroup
  } = useViewerActions();
  const {
    validateDraftCondition
  } = useValidateDraftCondition();
  const {
    disabled: isEditButtonDisabled,
    tooltipHeadingText,
    tooltipTitle
  } = editButtonsState || {};
  const alreadyHasGroups = !!internalDraftValue && internalDraftValue.conditions.size > 0;
  if (isReadOnly || alreadyHasGroups && (isAndGroup || !isInEditMode)) {
    return null;
  }
  const isEditorOpen = Boolean(draftCondition);
  const onAddFilterGroupClicked = evt => {
    evt.stopPropagation();
    if (isEditorOpen) {
      validateDraftCondition();
    }
    onAddFilterGroup();
  };
  const onAddFirstFilterGroupClicked = evt => {
    evt.stopPropagation();
    onAddFirstFilterGroup();
  };
  const isCurrentlyAddingNewGroup = Boolean(draftCondition && draftCondition.isAddingNew);
  if (alreadyHasGroups) {
    if (useOnePanel) {
      return /*#__PURE__*/_jsxs(Flex, {
        gap: "250",
        children: [/*#__PURE__*/_jsx(LogicGroupsDivider, {
          logicOperator: internalDraftValue.logicGroupName,
          layout: "vertical",
          showToggle: showLogicGroupOperatorToggle,
          isLast: true,
          showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
        }), /*#__PURE__*/_jsx(Box, {
          alignSelf: "end",
          paddingBlockEnd: showLogicGroupOperatorToggle ? '200' : '50',
          children: /*#__PURE__*/_jsx(Tooltip, {
            disabled: !isCurrentlyAddingNewGroup,
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "newCustomerDataFilters.filtersViewer.disabledAddGroupTooltip"
            }),
            children: /*#__PURE__*/_jsx(Button, {
              "data-selenium-info": "Or",
              "data-selenium-test": "fr-viewer-add-filter-btn",
              disabled: isCurrentlyAddingNewGroup,
              onClick: onAddFilterGroupClicked,
              size: "xs",
              use: "tertiary-light",
              responsive: false,
              children: /*#__PURE__*/_jsxs(Flex, {
                alignItems: "center",
                gap: "100",
                children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterGroupButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "newCustomerDataFilters.filtersViewer.addGroup"
                })]
              })
            })
          })
        })]
      });
    }
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(LogicGroupsDivider, {
        logicOperator: internalDraftValue.logicGroupName,
        layout: "horizontal",
        showToggle: showLogicGroupOperatorToggle,
        isLast: true,
        showLogicGroupOperatorToggles: showLogicGroupOperatorToggles
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isCurrentlyAddingNewGroup,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.disabledAddGroupTooltip"
        }),
        children: /*#__PURE__*/_jsx(Button, {
          "data-selenium-info": "Or",
          "data-selenium-test": "fr-viewer-add-filter-btn",
          disabled: isCurrentlyAddingNewGroup,
          onClick: onAddFilterGroupClicked,
          size: "sm",
          use: "tertiary-light",
          responsive: false,
          children: /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            gap: "100",
            children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterGroupButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
              message: "newCustomerDataFilters.filtersViewer.addGroup"
            })]
          })
        })
      })]
    });
  } else {
    return /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      paddingBlockStart: "250",
      children: [/*#__PURE__*/_jsx("p", {
        children: viewerEmptyFilters || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filtersViewer.emptyStateMessage"
        })
      }), /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isEditButtonDisabled,
        headingText: tooltipHeadingText,
        placement: "bottom",
        title: tooltipTitle,
        use: "longform",
        children: /*#__PURE__*/_jsxs(Button, {
          "data-onboarding": "add-filter-btn",
          "data-selenium-info": "Or",
          "data-selenium-test": "fr-viewer-add-filter-btn",
          disabled: isEditButtonDisabled,
          onClick: onAddFirstFilterGroupClicked,
          size: "sm",
          use: "tertiary",
          responsive: false,
          children: [/*#__PURE__*/_jsx(AddIcon, {}), addFilterButtonLabel || /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.filtersViewer.addFilter"
          })]
        })
      })]
    });
  }
};
export default ViewerAddGroup;